import { fetchPosNumberOfTransactions, MerchantHomeQuery } from "../../merchantHomeApi"
import { useMerchant } from "../../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { StatisticGraph } from "../../../../../../shared/components/statistic/StatisticGraph"

type StatisticsPosNumberOfTransactionsProps = Readonly<{
    periodInDays: number
}>

export function StatisticsPosNumberOfTransactions({ periodInDays }: StatisticsPosNumberOfTransactionsProps) {
    const { merchantId } = useMerchant()

    const { data } = useApiQuery(fetchPosNumberOfTransactions, {
        queryName: MerchantHomeQuery.STATISTICS_NUMBER_OF_TRANSACTIONS,
        dependencies: {
            merchantId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })
    if (!data) return null

    return (
        <StatisticGraph
            changeInPercentage={data?.reportSummary?.changeInPercentage}
            labels={data.posSales.map((entry) => entry.date)}
            datasets={data.posSales.map((entry) => entry.salesSummary.numberOfOrders)}
            title={data?.reportSummary?.numberOfOrders}
        />
    )
}
